module.exports = __webpack_public_path__ + "img/Education_new.bf2dbbab.jpg";